export default __webpack_public_path__ + "fonts/MYRIADPRO-REGULAR.39338481a9b2c3753b61115062caf9b4.woff";